__turbopack_context__.v({
  "drawerContent": "styles-module-scss-module__KG8oqq__drawerContent",
  "drawerForms": "styles-module-scss-module__KG8oqq__drawerForms",
  "drawerHandle": "styles-module-scss-module__KG8oqq__drawerHandle",
  "drawerHeader": "styles-module-scss-module__KG8oqq__drawerHeader",
  "drawerOverlay": "styles-module-scss-module__KG8oqq__drawerOverlay",
  "drawerTitle": "styles-module-scss-module__KG8oqq__drawerTitle",
  "flagButton": "styles-module-scss-module__KG8oqq__flagButton",
});
